// Pure helper for composing Telegram bot deep-links. The bot @username is
// fetched at runtime from GET /api/miniapp/bot-info (see api/client.ts +
// useBotInfo hook); callers feed it in here rather than reading from a
// build-time env var. Returns null when no username is available so the
// caller can render a disabled CTA instead of a dead link.
//
// Telegram start payloads accept only [A-Za-z0-9_-]; encodeURIComponent
// preserves that subset and percent-escapes anything else so a forwarded
// payload never silently breaks the deep-link target.
export const buildBotDeepLink = (
  username: string,
  payload?: string,
): string | null => {
  if (username === '') return null;
  const suffix =
    payload === undefined || payload === '' ? '' : `?start=${encodeURIComponent(payload)}`;
  return `https://t.me/${username}${suffix}`;
};
